import React from 'react';
import { WizardState } from '../types/WigWizard';

export function WigSummary({ state }: { state: WizardState }) {
  return <div className="bg-white pt-2 px-9 pb-3 text-sm leading-none text-left drop-shadow-cartItem lg:hidden">
    <ul className="grid grid-cols-2 grid-cols-[repeat(2,_minmax(auto,_0fr))] gap-y-3 gap-x-20 whitespace-nowrap">
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Pattern
        </p>
        <p className="font-semibold capitalize">
          {state.Product.replace(/-/g, ' ')}
        </p>
      </li>
      <li className="list-none">
        <p className="leading-none text-gray-600 uppercase">
          Color
        </p>
        <p className="font-medium capitalize">
          {state.Color}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Length
        </p>
        <p className="font-medium capitalize">
          {state.Length}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Closure
        </p>
        <p className="font-medium capitalize">
          {state.Type}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Adhesive
        </p>
        <p className="font-medium capitalize">
          {state.Adhesive}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Prep
        </p>
        <p className="font-medium capitalize">
          {state.Prep}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Cut
        </p>
        <p className="font-medium capitalize">
          {state.Cut}
        </p>
      </li>
      <li className="list-none">
        <p className="text-gray-600 uppercase">
          Part Style
        </p>
        <p className="font-medium capitalize">
        {state.Part_Style}
        </p>
      </li>
      {/* <li className="list-none">
        <p className="text-gray-600 uppercase">
          Size
        </p>
        <p className="font-semibold capitalize">
          {state.capSize || 'Photos needed' }
        </p>
      </li> */}
    </ul>
  </div>
}
